var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagForGermany({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.8125H20V12.1875H0V7.8125Z",
    fill: "#EC1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 3.125H3.125C1.05406 3.125 0 4.66406 0 6.5625V7.8125H20V6.5625C20 4.66406 18.9459 3.125 16.875 3.125Z",
    fill: "#25333A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.4375C0 15.3359 1.05406 16.875 3.125 16.875H16.875C18.9459 16.875 20 15.3359 20 13.4375V12.1875H0V13.4375Z",
    fill: "#F9CB38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagForGermany);
export default __webpack_public_path__ + "static/media/flag-for-germany.d6623d27ec960e27de222bf3a1916f1a.svg";
export { ForwardRef as ReactComponent };